<template>
  <div class="formBox" v-if="!(selectedLanguages.length === 1 && selectedLanguages[0] === 'en')">
    <h4 class="profile-header">Manage your language preference</h4>
    <hr />
    <label for="language-select" class="main-label">Select Language:</label>
    <select id="language-select" v-model="selectedLanguage" @change="saveLanguage">
      <option v-for="lang in filteredAvailableLanguages" :key="lang.code" :value="lang.code">
        {{ lang.name }}
      </option>
    </select>
  </div>
</template>

<script>
import api from "../api/api";
import { flashMessage } from "../functions.js";

export default {
  name: "LanguagePreference",
  props: ["userData", "brandData"],
  data() {
    return {
      selectedLanguage: "",
      selectedLanguages: [],
      availableLanguages: [
        { code: "af", name: "Afrikaans" },
        { code: "ak", name: "Akan" },
        { code: "sq", name: "Albanian" },
        { code: "am", name: "Amharic" },
        { code: "ar", name: "Arabic" },
        { code: "hy", name: "Armenian" },
        { code: "as", name: "Assamese" },
        { code: "ay", name: "Aymara" },
        { code: "az", name: "Azerbaijani" },
        { code: "bm", name: "Bambara" },
        { code: "ba", name: "Bashkir" },
        { code: "eu", name: "Basque" },
        { code: "be", name: "Belarusian" },
        { code: "bn", name: "Bengali" },
        { code: "bs", name: "Bosnian" },
        { code: "pt-br", name: "Brazilian Portuguese" },
        { code: "bg", name: "Bulgarian" },
        { code: "my", name: "Burmese" },
        { code: "yue", name: "Cantonese" },
        { code: "ca", name: "Catalan" },
        { code: "ceb", name: "Cebuano" },
        { code: "km", name: "Central Khmer" },
        { code: "ny", name: "Chichewa" },
        { code: "chk", name: "Chuukese" },
        { code: "co", name: "Corsican" },
        { code: "hr", name: "Croatian" },
        { code: "cs", name: "Czech" },
        { code: "da", name: "Danish" },
        { code: "dv", name: "Divehi" },
        { code: "nl", name: "Dutch" },
        { code: "en", name: "English" },
        { code: "eo", name: "Esperanto" },
        { code: "et", name: "Estonian" },
        { code: "ee", name: "Ewe" },
        { code: "fo", name: "Faroese" },
        { code: "fj", name: "Fijian" },
        { code: "fl", name: "Filipino" },
        { code: "fi", name: "Finnish" },
        { code: "fr", name: "French" },
        { code: "fr-ca", name: "French (Canada)" },
        { code: "gl", name: "Galician" },
        { code: "ka", name: "Georgian" },
        { code: "de", name: "German" },
        { code: "el", name: "Greek" },
        { code: "gn", name: "Guarani" },
        { code: "gu", name: "Gujarati" },
        { code: "ht", name: "Haitian Creole" },
        { code: "ha", name: "Hausa" },
        { code: "hw", name: "Hawaiian" },
        { code: "he", name: "Hebrew" },
        { code: "hi", name: "Hindi" },
        { code: "hmn", name: "Hmong" },
        { code: "hu", name: "Hungarian" },
        { code: "is", name: "Icelandic" },
        { code: "ig", name: "Igbo" },
        { code: "il", name: "Ilocano" },
        { code: "id", name: "Indonesian" },
        { code: "iu", name: "Inuktitut" },
        { code: "ga", name: "Irish" },
        { code: "it", name: "Italian" },
        { code: "ja", name: "Japanese" },
        { code: "jv", name: "Javanese" },
        { code: "kn", name: "Kannada" },
        { code: "kk", name: "Kazakh" },
        { code: "rw", name: "Kinyarwanda" },
        { code: "ko", name: "Korean" },
        { code: "ku", name: "Kurdish" },
        { code: "kb", name: "Kurdish (Sorani)" },
        { code: "ky", name: "Kyrgyz" },
        { code: "lo", name: "Lao" },
        { code: "la", name: "Latin" },
        { code: "lv", name: "Latvian" },
        { code: "ln", name: "Lingala" },
        { code: "lt", name: "Lithuanian" },
        { code: "lg", name: "Luganda" },
        { code: "lb", name: "Luxembourgish" },
        { code: "mk", name: "Macedonian" },
        { code: "mg", name: "Malagasy" },
        { code: "ms", name: "Malay" },
        { code: "ml", name: "Malayalam" },
        { code: "mt", name: "Maltese" },
        { code: "mr", name: "Marathi" },
        { code: "mh", name: "Marshallese" },
        { code: "mn", name: "Mongolian" },
        { code: "mi", name: "Māori" },
        { code: "ne", name: "Nepali" },
        { code: "no", name: "Norwegian" },
        { code: "nb", name: "Norwegian Bokmål" },
        { code: "oc", name: "Occitan" },
        { code: "or", name: "Odia" },
        { code: "om", name: "Oromo" },
        { code: "ps", name: "Pashto" },
        { code: "fa", name: "Persian" },
        { code: "pl", name: "Polish" },
        { code: "pt", name: "Portuguese" },
        { code: "pa", name: "Punjabi" },
        { code: "qu", name: "Quechua" },
        { code: "ro", name: "Romanian" },
        { code: "ru", name: "Russian" },
        { code: "sm", name: "Samoan" },
        { code: "gd", name: "Scottish Gaelic" },
        { code: "sr", name: "Serbian (Cyrillic)" },
        { code: "sr-latn", name: "Serbian (Latin)" },
        { code: "sn", name: "Shona" },
        { code: "zh", name: "Simplified Chinese" },
        { code: "sd", name: "Sindhi" },
        { code: "si", name: "Sinhalese" },
        { code: "sk", name: "Slovak" },
        { code: "sl", name: "Slovenian" },
        { code: "so", name: "Somali" },
        { code: "st", name: "Southern Sotho" },
        { code: "es", name: "Spanish" },
        { code: "su", name: "Sundanese" },
        { code: "sw", name: "Swahili" },
        { code: "sv", name: "Swedish" },
        { code: "tl", name: "Tagalog" },
        { code: "ty", name: "Tahitian" },
        { code: "tg", name: "Tajik" },
        { code: "ta", name: "Tamil" },
        { code: "tt", name: "Tatar" },
        { code: "te", name: "Telugu" },
        { code: "th", name: "Thai" },
        { code: "bo", name: "Tibetan" },
        { code: "ti", name: "Tigrinya" },
        { code: "to", name: "Tongan" },
        { code: "zh-tw", name: "Traditional Chinese" },
        { code: "ts", name: "Tsonga" },
        { code: "tr", name: "Turkish" },
        { code: "tk", name: "Turkmen" },
        { code: "uk", name: "Ukrainian" },
        { code: "ur", name: "Urdu" },
        { code: "ug", name: "Uyghur" },
        { code: "uz", name: "Uzbek" },
        { code: "vi", name: "Vietnamese" },
        { code: "cy", name: "Welsh" },
        { code: "fy", name: "Western Frisian" },
        { code: "xh", name: "Xhosa" },
        { code: "yi", name: "Yiddish" },
        { code: "yo", name: "Yoruba" },
        { code: "zu", name: "Zulu" }
      ],
    };
  },
  async mounted() {
    try {
    // Get user's current language if ind_id exists
      if (this.userData?.ind_id) {
        const res = await api.post("/get-language-preference", {
          ind_id: this.userData.ind_id
        });
        this.selectedLanguage = res.data?.default_language || "en";
      } else {
        console.log("No ind_id provided. Skipping individual language preference.");
        this.selectedLanguage = "en";
      }

      // Get allowed languages for suborg
      if (this.userData?.suborgs) {
        let suborgIds = [];
        
        // Normalize suborgs data to array format
        if (Array.isArray(this.userData.suborgs)) {
          suborgIds = this.userData.suborgs;
        } else if (typeof this.userData.suborgs === 'string') {
          suborgIds = this.userData.suborgs.split(',').map(id => id.trim()).filter(id => id);
        } else {
          suborgIds = [this.userData.suborgs];
        }
        
        // Filter out any invalid/empty IDs
        suborgIds = suborgIds.filter(id => id && id !== '');

        // Check if suborgId is valid before making API call
        if (suborgIds.length === 0) {
          console.log("No valid suborg ID found. Skipping API call.");
          return;
        }

        try {
          // Make API calls for all suborg IDs
          const apiPromises = suborgIds.map(async (suborgId) => {
            try {
              const langRes = await api.post("/get-selected-languages-suborg", {
                suborg_id: suborgId
              });
              return {
                suborgId,
                languages: langRes.data?.languages || [],
                languageCount: (langRes.data?.languages || []).length
              };
            } catch (err) {
              console.error(`Error fetching languages for suborg ${suborgId}:`, err.message);
              return {
                suborgId,
                languages: [],
                languageCount: 0
              };
            }
          });

          // Wait for all API calls to complete
          const results = await Promise.all(apiPromises);
          
          // Find the suborg with the most languages
          const bestSuborg = results.reduce((best, current) => {
            return current.languageCount > best.languageCount ? current : best;
          });
          
          if (bestSuborg.languageCount > 0) {
            this.selectedLanguages = bestSuborg.languages;
            console.log(`Selected suborg ${bestSuborg.suborgId} with ${bestSuborg.languageCount} languages`);
          } else {
            console.log("No suborg returned any languages. Using fallback.");
            this.selectedLanguages = ["en"];
          }

          // Set default selection if current isn't available
          if (!this.selectedLanguages.includes(this.selectedLanguage)) {
            this.selectedLanguage = this.selectedLanguages[0] || "en";
          }
          
        } catch (e) {
          console.error("Error fetching suborg languages:", e.message);
          // Set fallback values on error
          this.selectedLanguages = ["en"];
          this.selectedLanguage = "en";
        }
      }
    } catch (e) {
      console.error("Error loading languages:", e);
      this.selectedLanguage = "en";
      this.selectedLanguages = ["en"];
    }
  },
  computed: {
    filteredAvailableLanguages() {
      if (!this.selectedLanguages || !this.selectedLanguages.length) {
        return this.availableLanguages;
      }

      const selectedCodes = Array.isArray(this.selectedLanguages) 
        ? this.selectedLanguages 
        : [this.selectedLanguages];
      
      return this.availableLanguages.filter(lang => 
        selectedCodes.includes(lang.code)
      );
    }
  },
  methods: {
    saveLanguage() {
      if (!this.userData?.ind_id) {
        console.error("Cannot save - missing userData.ind_id");
        return;
      }

      api.post("/save-language-preference", {
        ind_id: this.userData.ind_id,
        language: this.selectedLanguage || "en",
      })
        .then(async () => {
          flashMessage(
            this.$flashMessage,
            this.brandData?.accent_color1 || "#F47820",
            this.brandData?.flash_text_color || "#ffffff",
            "Language preference saved!"
          );

          // Add history log
          try {
            await api.post(`/create-user-history-log`, {
              ind_id: this.userData.ind_id,
              email: this.userData.email,
              screen: 'My Profile Screen',
              action: `Language Preference Changed`,
              action_description: `Changed language preference to: ${this.selectedLanguage || "en"}`,
            });
          } catch (err) {
            console.error('History log error:', err);
          }
        })
        .catch((e) => {
          console.error("Save error:", e);
          flashMessage(
            this.$flashMessage,
            this.brandData?.accent_color1 || "#F47820",
            this.brandData?.flash_text_color || "#ffffff",
            "Error saving language preference"
          );
        });
    }
  }
};
</script>
<style>
.formBox {
  margin-top: 20px;
}
select {
  width: 100%;
  padding: 12px;
  margin-top: 8px;
  border: 1px solid grey !important;
  border-radius: 4px;
  max-width: 50%;
  background-color: white;
  color: black;
  appearance: none;         /* Removes OS default styles */
  -webkit-appearance: none; /* For Safari */
  -moz-appearance: none;    /* For Firefox */
}

.profile-header {
  margin-bottom: 10px;
}
</style>